export enum MeridianPropertyType {
    SFR = 0,
    PUD = 1,
    CONDO = 2,
    COOP = 3,
    MANUFACTURED = 4,
    TWO_UNITS = 8,
    THREE_UNITS = 9,
    FOUR_UNITS = 10,
    MODULAR = 11,
    ROWHOUSE = 12,
    LAND = 13,
}